import { useEffect, useState } from "react";
import documentApi from "../../api/documentApi";
import { toast } from "react-hot-toast";

interface WarningDeletePopupProps {
    fileId: number | null;
    onClose: () => void;
    onCancel: () => void;
    onSuccess: () => void;
}

function WarningDeletePopup({ fileId, onClose, onCancel, onSuccess }: WarningDeletePopupProps) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setTimeout(() => setShow(true), 10);
    }, []);

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            setShow(false);
            setTimeout(onClose, 300);
        }
    };

    const handleDelete = async () => {
        if (!fileId) return;

        try {
            await documentApi.deleteDocument(fileId);
            setShow(false);
            setTimeout(() => {
                onSuccess();
                onClose();
            }, 300);
        } catch (err) {
            toast.error("Xóa file thất bại!");
        }
    };

    return (
        <div
            className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.5)] z-50 flex justify-center items-center transition-opacity duration-300"
            onClick={handleOverlayClick}
            style={{ opacity: show ? 1 : 0 }}
        >
            <div
                className={`relative w-[90%] lg:w-[400px] bg-white p-[20px] rounded-box transform transition-all duration-300
                    ${show ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"}`}
            >
                <h2 className="text-secondary font-bold text-[20px] mt-[20px] text-center">
                    Bạn thực sự muốn xóa nó?
                </h2>

                <div className="flex justify-center mt-[40px]">
                    <button
                        onClick={handleDelete}
                        className="bg-red-500 text-white px-[15px] py-[8px] rounded-[5px] min-w-[100px] hover:bg-red-600"
                    >
                        Xóa file
                    </button>
                    <button
                        onClick={onCancel}
                        className="ml-[20px] bg-secondary opacity-90 hover:opacity-100 text-white px-[15px] py-[8px] rounded-[5px] min-w-[100px]"
                    >
                        Hủy
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WarningDeletePopup;
